// src/screens/private/AvailabilityPage.js

import React, { useState, useEffect } from 'react';
import { db } from '../../firebaseConfig';
import {
  collection,
  onSnapshot
} from 'firebase/firestore';
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
} from '@mui/material';

// Falls du einen TenantContext nutzt:
import { useTenant } from '../../contexts/TenantContext';

// Import der neuen Komponenten
import Verfuegbarkeiten from '../../components/AvailabilityPage/Verfuegbarkeiten';
import Abwesenheiten from '../../components/AvailabilityPage/Abwesenheiten';

function AvailabilityPage() {
  const { tenantId } = useTenant(); // tenantId einbinden, falls Context vorhanden

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');

  const [appointments, setAppointments] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Mitarbeiter laden
  useEffect(() => {
    if (!tenantId) return;

    const unsubEmp = onSnapshot(collection(db, 'tenants', tenantId, 'employees'), (snapshot) => {
      const data = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
      setEmployees(data);
    });

    return () => {
      unsubEmp();
    };
  }, [tenantId]);

  // Termine (Appointments) laden
  useEffect(() => {
    if (!tenantId) return;

    const unsubAppointments = onSnapshot(
      collection(db, 'tenants', tenantId, 'appointments'),
      (snapshot) => {
        const data = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
        setAppointments(data);
      }
    );

    return () => {
      unsubAppointments();
    };
  }, [tenantId]);

  // Snackbar
  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Mitarbeiter auswählen */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Mitarbeiter wählen
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Mitarbeiter</InputLabel>
                <Select
                  value={selectedEmployee}
                  label="Mitarbeiter"
                  onChange={(e) => {
                    setSelectedEmployee(e.target.value);
                  }}
                  // Stelle sicher, dass kein ungültiger Wert gesetzt wird
                  displayEmpty
                >
                  {/* <MenuItem value="">
                    <em>Bitte wählen</em>
                  </MenuItem> */}
                  {employees.map((emp) => (
                    <MenuItem key={emp.id} value={emp.id}>
                      {emp.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      {/* Nur anzeigen, wenn ein Mitarbeiter ausgewählt ist */}
      {selectedEmployee ? (
        <>
          {/* Verfügbarkeiten */}
          <Verfuegbarkeiten
            tenantId={tenantId}
            selectedEmployee={selectedEmployee}
            showSnackbar={showSnackbar}
          />

          {/* Abwesenheiten */}
          <Abwesenheiten
            tenantId={tenantId}
            selectedEmployee={selectedEmployee}
            showSnackbar={showSnackbar}
            appointments={appointments} // Weitergabe der Termine als Prop
          />
        </>
      ) : (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" color="textSecondary">
            Bitte wählen Sie einen Mitarbeiter aus, um Verfügbarkeiten und Abwesenheiten zu verwalten.
          </Typography>
        </Paper>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </Container>
  );
}

export default AvailabilityPage;
